function Infowijs(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <img src="https://infowijs.nl/assets/images/infowijs.svg" alt="Infowijs" className="w-[139px]" {...props} />
  )
}

export default Infowijs
